import React from "react";
import logo from "../img/logo.png";
import { BiFootball, BiBasketball } from "react-icons/bi";
import { FaVolleyballBall } from "react-icons/fa";
import { FcSportsMode } from "react-icons/fc";
import { GiTennisCourt, GiBoxingGlove } from "react-icons/gi";

export default function HomeHakkimdaj() {
	return (
		<div
			className="container"
			style={{ maxWidth: "960px", marginBottom: "70px" }}
		>
			<div className="paper">
				<div className="row">
					<div className="col-12">
						<div className="d-flex align-items-center gap-4  p-5">
							<img src={logo} className="radius-10" alt="" />
							<p className="text-justify px-3">
								<p className="text-justify">
									İlk amacımız çocuklarımızı yanlış tecrübelerle
									spordan uzaklaştırmayıp aksine sporu hayatlarının
									içine katmaktır.
								</p>
								4-18 yaş arası lisanslı sporcu olma fırsatı. <br />
								Basketbol <BiBasketball className="fs-5" />
								<br />
								Futbol <BiFootball className="fs-5" /> <br /> Voleybol{" "}
								<FaVolleyballBall />
								<br /> Jimnastik <FcSportsMode className="fs-5" />
								<br /> Masa Tenisi <GiTennisCourt className="fs-5" />
								<br /> Boks <GiBoxingGlove className="fs-5" />
								<br />
								Spor ahlakı ve spor yapma alışkanlığı kazandırma.
							</p>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
